/**
 * @generated SignedSource<<9a6b3baa19b732e15c55ff46d5817d86>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMarketSettings_nftItem$data = {
  readonly contract: {
    readonly address: string | null;
  } | null;
  readonly tokenId: string | null;
  readonly " $fragmentType": "useMarketSettings_nftItem";
};
export type useMarketSettings_nftItem$key = {
  readonly " $data"?: useMarketSettings_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMarketSettings_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useMarketSettings_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftTokenContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "08950db23e2c85dda5ddf3cda029195f";

export default node;
